import React from "react";
import "../styles/Sidebar.css";
import SidebarOption from "./SidebarOption";
import AddIcon from "@material-ui/icons/Add";
import DuoIcon from "@material-ui/icons/Duo";
import NoteIcon from "@material-ui/icons/Note";
import StarIcon from "@material-ui/icons/Star";
import InboxIcon from "@material-ui/icons/Inbox";
import PhoneIcon from "@material-ui/icons/Phone";
import NearMeIcon from "@material-ui/icons/NearMe";
import PersonIcon from "@material-ui/icons/Person";
import { Button, IconButton } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import LabelImportantIcon from "@material-ui/icons/LabelImportant";
import { useDispatch } from "react-redux";
import { openSendMessage } from "../features/mailSlice";

function Sidebar() {
	const dispatch = useDispatch();

	return (
		<div className="sidebar">
			<Button
				startIcon={<AddIcon fontSize="large" />}
				className="sidebar__compose"
				onClick={() => dispatch(openSendMessage())}
			>
				Compose
			</Button>
			<SidebarOption
				Icon={InboxIcon}
				title="Inbox"
				number={87}
				// selected={true}
			/>
			<SidebarOption Icon={StarIcon} title="Starred" number={87} />
			<SidebarOption Icon={AccessTimeIcon} title="Snoozed" number={16} />
			<SidebarOption Icon={LabelImportantIcon} title="Important" number={8} />
			<SidebarOption Icon={NearMeIcon} title="Sent" number={7} />
			<SidebarOption Icon={NoteIcon} title="Drafts" number={21} />
			<SidebarOption Icon={ExpandMoreIcon} title="More" number={66} />

			<div className="sidebar__footer">
				<div className="sidebar__footerIcons">
					<IconButton>
						<PersonIcon />
					</IconButton>
					<IconButton>
						<DuoIcon />
					</IconButton>
					<IconButton>
						<PhoneIcon />
					</IconButton>
				</div>
			</div>
		</div>
	);
}

export default Sidebar;
